// User Constants
export const USER_URL = `/api/user`;
export const ALL_USERS = `${USER_URL}/all_users`;
export const CREATE_USER = `${USER_URL}/create_user`;
export const BREAK_DOWN = `${USER_URL}/breakdown`;
export const UPDATE_PENDING_USER = `${USER_URL}/update_pending_user`;
export const ABOUT_ME_URL = `${USER_URL}/aboutme`; // currently not used
export const UPDATE_ME_URL = `${USER_URL}/updateme`;
